module.exports = __webpack_public_path__ + "static/media/IMG_1206.ba7ed114.jpg";